<template>
    <div id="interaction-box">
        <div id="toolbar" class="bg-dark">
            <slot name="main"></slot>
            <div id="toolbar-buttons">
                <div style="flex: 1"></div>
                <div v-if="currentView" id="fold-in" @click="toggleContent(undefined)">
                    einklappen
                </div>
                <div v-for="(title, key) in interactions" :key="key" class="toolbar-interaction">
                    <b-button
                        :variant="currentView === key ? 'light' : 'primary'"
                        @click="toggleContent(key)"
                    >
                        {{ title }}
                    </b-button>
                </div>
            </div>
        </div>
        <transition name="fadeUp" mode="out-in">
            <div v-show="currentView" class="content-area">
                <slot :name="currentView"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "InteractionBar",
    props: {
        interactions: {
            type: Object,
            default: () => []
        }
    },
    data() {
        return {
            currentView: false
        };
    },
    methods: {
        toggleContent(newView) {
            this.currentView = newView;
        }
    }
};
</script>

<style scoped>
#interaction-box {
    display: flex;
    flex-wrap: wrap;
}
#toolbar {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.42);
    z-index: 1;
}
#toolbar-buttons {
    display: flex;
    flex: 2 1 auto;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.toolbar-interaction {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 12px;
}
#fold-in {
    color: white;
    text-decoration: dotted underline;
    line-height: 1.1em;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 12px;
}

#fold-in:hover {
    text-decoration: underline;
}
.fadeUp-enter-active {
    animation: fadeUp 0.5s;
}

.fadeUp-leave-active {
    animation: fadeUp 0.4s reverse;
}

.fade-enter-active,
.fade-leave-active {
    transition: background-color 0.2s;
}

@keyframes fadeUp {
    0% {
        height: 0px;
    }
    100% {
        height: auto;
    }
}
</style>
